import React from 'react';
import HomeHeader from '@/src/shared/components/HomeHeader';
import { Pages } from '@/types/pages';
import Footer from '@/src/containers/Landings/Footer';
import Sections from '@/src/containers/TermsOfService/components/Sections';

const source: Pages = 'terms-of-service-landing';

const TermsOfService = () => {
  return (
    <>
      <HomeHeader bgColor="white" />
      <Sections />
      <Footer />
    </>
  );
};

TermsOfService.withIntercomChatBot = true;
TermsOfService.pageName = source;

export default TermsOfService;
